/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_MAX_INVITES } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateMaxInvitesMethods extends IPluginMethodMap {
  getUpdateMaxInvites(args: any): Promise<any>;
}

export class UpdateMaxInvitesService implements IAgentPlugin {
  readonly methods: IUpdateMaxInvitesMethods;

  constructor() {
    this.methods = {
      getUpdateMaxInvites: this.getUpdateMaxInvites.bind(this),
    };
  }

  async getUpdateMaxInvites(args: any) {
    console.log(`service args`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const filter = args.id
      ? {
          _id: args.id,
        }
      : {};
    const update =
      args?.value >= 0
        ? {
            maxInvites: args.value,
          }
        : {};
    try {
      if (client) {
        console.log("updateMax==>", args);
        const res = await client.mutate({
          mutation: UPDATE_MAX_INVITES,
          variables: {
            filter: filter,
            update: update,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
